import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { BranchGroupsContextImport } from "../../../../provider/branch/branch_groups/BranchGroupsContextProvider";

const BranchGroupsActions = () => {
  const { showSearch, updateShowSearch } = BranchGroupsContextImport();

  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default BranchGroupsActions;
